// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SystemPresentationTemplateTableQueryVariables = Types.Exact<{
  systemTemplateWhere: Types.PresentationTemplateWhereInput;
}>;


export type SystemPresentationTemplateTableQuery = { __typename?: 'Query', presentationTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & SystemPresentationTemplateTable_PresentationTemplateFragment
      ) | null } | null> | null } };

export type SystemPresentationTemplateTable_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, isPinned: boolean, type: Types.PresentationTemplateType, systemTemplateKind?: Types.PresentationTemplateSystemTemplateKind | null, updatedAt: Time, user?: { __typename?: 'User', id: string, displayName: string } | null };

export const Operations = {
  Query: {
    SystemPresentationTemplateTable: 'SystemPresentationTemplateTable' as const
  },
  Fragment: {
    SystemPresentationTemplateTable_PresentationTemplate: 'SystemPresentationTemplateTable_PresentationTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const SystemPresentationTemplateTable_PresentationTemplateFragmentDoc = gql`
    fragment SystemPresentationTemplateTable_PresentationTemplate on PresentationTemplate {
  id
  displayName
  isPinned
  type
  systemTemplateKind
  updatedAt
  user {
    id
    displayName
  }
}
    `;
export const SystemPresentationTemplateTableDocument = gql`
    query SystemPresentationTemplateTable($systemTemplateWhere: PresentationTemplateWhereInput!) {
  presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, $systemTemplateWhere]}
  ) {
    edges {
      node {
        ...SystemPresentationTemplateTable_PresentationTemplate
      }
    }
  }
}
    ${SystemPresentationTemplateTable_PresentationTemplateFragmentDoc}`;

/**
 * __useSystemPresentationTemplateTableQuery__
 *
 * To run a query within a React component, call `useSystemPresentationTemplateTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemPresentationTemplateTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemPresentationTemplateTableQuery({
 *   variables: {
 *      systemTemplateWhere: // value for 'systemTemplateWhere'
 *   },
 * });
 */
export function useSystemPresentationTemplateTableQuery(baseOptions: Apollo.QueryHookOptions<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>(SystemPresentationTemplateTableDocument, withFetchPolicyContext(options));
      }
export function useSystemPresentationTemplateTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>(SystemPresentationTemplateTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSystemPresentationTemplateTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>(SystemPresentationTemplateTableDocument, withFetchPolicyContext(options));
        }
export type SystemPresentationTemplateTableQueryHookResult = ReturnType<typeof useSystemPresentationTemplateTableQuery>;
export type SystemPresentationTemplateTableLazyQueryHookResult = ReturnType<typeof useSystemPresentationTemplateTableLazyQuery>;
export type SystemPresentationTemplateTableSuspenseQueryHookResult = ReturnType<typeof useSystemPresentationTemplateTableSuspenseQuery>;
export type SystemPresentationTemplateTableQueryResult = Apollo.QueryResult<SystemPresentationTemplateTableQuery, SystemPresentationTemplateTableQueryVariables>;